import {
  FETCH_ORDERS_OF_INBOUND_UNACKNOWLEDGED_KEG_SHIPMENTS_REQUEST,
  FETCH_ORDERS_OF_INBOUND_UNACKNOWLEDGED_KEG_SHIPMENTS_SUCCESS,
  FETCH_ORDERS_OF_INBOUND_UNACKNOWLEDGED_KEG_SHIPMENTS_FAILURE,
} from '../../../actions/actionTypes'

import fetchStatusesByCustomerIdReducerCreator from '../higherOrderReducers/reducerCreators/byCustomerId'

export default fetchStatusesByCustomerIdReducerCreator(
  FETCH_ORDERS_OF_INBOUND_UNACKNOWLEDGED_KEG_SHIPMENTS_REQUEST,
  FETCH_ORDERS_OF_INBOUND_UNACKNOWLEDGED_KEG_SHIPMENTS_SUCCESS,
  FETCH_ORDERS_OF_INBOUND_UNACKNOWLEDGED_KEG_SHIPMENTS_FAILURE,
)
